import {PageBaseSection} from "../PageBaseSection";
import {SynapiPredicate} from "../../Synapi/SynapiPredicate";

export enum EvenementSitPeriods{
  TODAY = "today",
  WEEKEND = "weekend",
  MONTH = "month",
  NEXT = "next",
}
export class PageEvenementSitSectionPeriods {
  cyclic_period?: EvenementSitPeriods;
  from: string;
  to: string;
  selection_sit: string;
  subtitle: string;
  active = true;
}

export class PageEvenementSitSection extends PageBaseSection{
  periods: PageEvenementSitSectionPeriods[];
}
